import { coreService } from "../../../../services/coreService";
import { buildQuery } from "../../../../lib/network";

export const deleteInspectionItemStatus =
  (networkHeaders: any) =>
  ({ id, sectionId, itemId }: { id: number; sectionId: number; itemId: number }) => {
    return buildQuery(
      coreService.inspectionsSectionsItemsStatusDelete(id, sectionId, itemId, { headers: networkHeaders }),
      (response) => {
        return response.data;
      },
    );
  };
